// @flow
import React, {PureComponent} from "react";
import {Polyline} from "react-google-maps";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {
    getCurvedPolylinePath,
    getLatLngFromLatLngLiteral
} from "../../../Utils/MapUtils";
import CurrentRideSelectors from "../../../Store/Ducks/CurrentRide/selectors";
import AppSelectors from "../../../Store/Ducks/App/selectors";
import BackendOperations from "../../../Store/Middleware/Backend/operations";
import type {LatLngLiteral} from "../../../Utils/MapUtils";


const MINIMUM_WALKING_MAP_DISTANCE_METERS = 10;
const MAXIMUM_WALKING_MAP_DISTANCE_METERS = 1000;

const isValidDistanceForWalkingMap = (distance: number) => {
    return (MINIMUM_WALKING_MAP_DISTANCE_METERS < distance && distance < MAXIMUM_WALKING_MAP_DISTANCE_METERS);
};

type ConnectedProps = {|
    walkingMapGeometry: Polyline,
    riderLocation: LatLngLiteral,
    pickup: LatLngLiteral,
    onGetWalkingMap: () => mixed,
    isRideAccepted: boolean,
    isPendingWalkingMap: boolean,
    distanceFromRiderToPickup: number,
|};

type State = {
    requestedWalkingMap: boolean
};

class RideWalkingMap extends PureComponent<ConnectedProps, State> {

    constructor(props) {
        super(props);
        this.state = {
            requestedWalkingMap: false
        };
    }

    static getDerivedStateFromProps(props, state) {

        if (state.requestedWalkingMap) {
            return state;
        }
        if (!(props.isRideAccepted && props.pickup && props.riderLocation)) {
            return state;
        }
        if (!isValidDistanceForWalkingMap(props.distanceFromRiderToPickup)) {
            return state;
        }
        props.onGetWalkingMap();
        return {requestedWalkingMap: true};
    }

    render() {
        if (!(this.props.isRideAccepted && this.props.pickup && this.props.riderLocation)) {
            return null;
        }
        if (!isValidDistanceForWalkingMap(this.props.distanceFromRiderToPickup)) {
            return null;
        }
        let walkingPath;
        if (this.props.walkingMapGeometry) {
            walkingPath = this.props.walkingMapGeometry;
        } else if (!this.props.isPendingWalkingMap) {
            // If we don't have a proper geometry and we are not pending, the request failed
            walkingPath = getCurvedPolylinePath(
                getLatLngFromLatLngLiteral(this.props.pickup),
                getLatLngFromLatLngLiteral(this.props.riderLocation));
        } else {
            return null;
        }
        return (<Polyline
            path={walkingPath}
            options={{
                geodesic: true,
                strokeOpacity: 1,
                strokeColor: "grey"
            }}
        />);
    }
}

const mapStateToProps = (state, props) => {
    return {
        walkingMapGeometry: CurrentRideSelectors.getWalkingMapGeometry(state),
        riderLocation: AppSelectors.getRiderLocation(state),
        pickup: CurrentRideSelectors.getPickup(state),
        isRideAccepted: CurrentRideSelectors.isRideAccepted(state),
        isPendingWalkingMap: CurrentRideSelectors.isPendingWalkingMap(state),
        distanceFromRiderToPickup: CurrentRideSelectors.getDistanceFromRiderToPickup(state),
    };
};
const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onGetWalkingMap: BackendOperations.doGetWalkingMap,
        },
        dispatch);
};
export default connect(mapStateToProps, mapActionsToProps)(RideWalkingMap);



// WEBPACK FOOTER //
// ./src/Components/Map/WalkingMap/RideWalkingMap.js